import { useCallback, useState } from "react";
import img1 from "../../assets/img/37.png";
import img2 from "../../assets/img/38.png";
import logo1 from "../../assets/img/logoPro.png";
import authDark from "../../assets/img/forgot-password.png";
import { Link, useNavigate } from "react-router-dom";
import useApiRequest from "../../Hooks/apiReq";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { uiAction } from "../../Redux/Slices/uiSlice";
import { APP_VERSION } from "../../Utils/AppVersion";
import Loader from "../Loader";
import { FaAngleDown } from "react-icons/fa";
const ForgetPassword = () => {
  const [lastClicked, setLastClicked] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loginid = useSelector((state) => state.uiReducers.loginid);
  const [loginData, setLoginData] = useState({
    LoginId: "",
  });
  const { error, loading, recallRequest, response, sendApiRequest, status } =
    useApiRequest();
  const handleSendOtp = async () => {
    // api call restriction
    const now = new Date().getTime();
    if (now - lastClicked < 3000) {
      return;
    }
    setLastClicked(now);
    // validation and api call
    if (!loginid || loginid?.trim() === "") {
      toast.error("LoginId is required");
      return;
    }
    sendApiRequest(
      "POST",
      "/Auth/forget-password",
      {
        strAssociateCode: loginid,
        AppVersion: APP_VERSION,
        Action: "SendOTP",
      },
      {
        onSuccess: (res) => {
          dispatch(uiAction.setOTPResponce(res.data));
          toast.success(res.message);
          navigate(`/otp-verification`, { replace: true });
        },
      },
    );
  };
  const handleChange = useCallback((e) => {
    const { id, value } = e.target;
    dispatch(uiAction.setLoginid(value));
  }, []);
  const handlekeyPress = (e) => {
    if (e.key === "Enter") {
      handleSendOtp();
    }
  };
  return (
    <main className="main" id="top">
      <div className="container-fluid bg-body-tertiary dark__bg-gray-1200 ">
        <div
          className="bg-holder bg-auth-card-overlay"
          style={{ backgroundImage: `url(${img1})` }}
        ></div>
        <div className="row flex-center position-relative min-vh-100 g-0 py-5">
          <div className="col-11 col-sm-10 col-xl-8">
            <div className="card border border-translucent auth-card">
              <div className="card-body pe-md-0">
                <div className="row align-items-center gx-0 gy-7">
                  <div className="col-auto bg-body-highlight dark__bg-gray-1100 rounded-3 position-relative overflow-hidden auth-title-box">
                    <div
                      className="bg-holder"
                      style={{ backgroundImage: `url(${img2})` }}
                    ></div>
                    <div className="position-relative px-4 px-lg-7 pt-7 pb-7 pb-sm-5 text-center text-md-start pb-lg-7 pb-md-7">
                      <h3 className="mb-3 text-body-emphasis fs-7">
                        Don’t worry — it happens to the best of us.
                      </h3>
                      <p className="text-body-tertiary">
                        We’ll help you get back into your account in no time.
                      </p>
                      <ul className="list-unstyled mb-0 w-max-content w-md-auto">
                        <li className="d-flex align-items-center">
                          <span className="uil uil-check-circle text-success me-2"></span>
                          <span className="text-body-tertiary fw-semibold">
                            RAV Property
                          </span>
                        </li>
                        <li className="d-flex align-items-center">
                          <span className="uil uil-check-circle text-success me-2"></span>
                          <span className="text-body-tertiary fw-semibold">
                            RAV Organics
                          </span>
                        </li>
                      </ul>
                    </div>

                    <div className="position-relative z-n1 mb-6 d-none d-md-block text-center mt-md-15">
                      <img
                        className="auth-title-box-img d-dark-none"
                        src={authDark}
                        alt=""
                      />
                      <img
                        className="auth-title-box-img d-light-none"
                        src={authDark}
                        alt="authpic"
                      />
                    </div>
                  </div>
                  <div class="mx-auto col">
                    <div class="text-center">
                      <a
                        class="d-inline-block text-decoration-none"
                        data-discover="true"
                      >
                        <div class="d-flex flex-center text-decoration-none mb-2">
                          <img alt="Rav" width="158" src={logo1} />
                        </div>
                      </a>
                    </div>
                    <div class="auth-form-box">
                      <div class="px-xxl-3">
                        <div class="text-center mb-6">
                          <h4 class="text-body-highlight textColor">
                            Forgot your password?
                          </h4>
                          <p class="text-center mb-7">
                            Enter your Login Id below and We will Send An Otp On
                            registered Mobile Number to reset it.
                          </p>
                          <div className="d-flex align-items-center  mb-3">
                            <input
                              onChange={handleChange}
                              autoComplete="off"
                              onKeyDown={handlekeyPress}
                              class="form-control flex-1"
                              id="LoginId"
                              type="text"
                              placeholder="Enter your registered ID to access your world"
                            />
                            <button
                              onClick={handleSendOtp}
                              class="btn  btn-primary ms-2"
                            >
                              Send <FaAngleDown size={16} />
                            </button>
                          </div>
                          <p class="text-end ">
                            <Link
                              to="/login"
                              class="fs-9 fw-bold"
                              data-discover="true"
                            >
                              Return to Login?
                            </Link>
                          </p>

                          {/* <form className="d-flex  mb-3">
                            <input
                              className="form-control flex-1"
                              id="LoginId"
                              type="text"
                              placeholder="Login Id"
                              value={loginid}
                              onChange={handleChange}
                              onKeyDown={handlekeyPress}
                            />
                          </form> */}
                          {/* <div className="col-12 mb-3">
                            <InputBox
                              id="LoginId"
                              value={loginid}
                              onChange={handleChange}
                              type="text"
                              placeholder="Login Id"
                              label="Login Id"
                              required={true}
                              onkeydown={handlekeyPress}
                            />
                          </div> */}
                          <div class="row flex-between-center">
                            {/* <div class="col-auto">
                              <button
                                type="button"
                                onClick={handleSendOtp}
                                class="btn btn-dark"
                                fdprocessedid="okvtgh"
                              >
                                Send
                                <HiArrowTopRightOnSquare size={16} className=" mb-1 ms-1" />
                              </button>
                            </div> */}
                            {/* <div class="col-auto">
                              <Link
                                to="/login"
                                class="fs-9 fw-bold text-end"
                                data-discover="true"
                              >
                                Return to Login?
                              </Link>

                            </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
      {loading && <Loader />}
    </main>
  );
};

export default ForgetPassword;
